import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'brCurrency'})
export class BrCurrencyPipe implements PipeTransform {
  transform(value: number): string {
    return 'R$ ' + this.format(value);
  }

  format(number){
    var n = number, 
      c = 2, 
      s = n < 0 ? "-" : "", 
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
      j = (j = i.length) > 3 ? j % 3 : 0;
      
    return s + (j ? i.substr(0, j) + '.' : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + '.') + (c ? ',' + Math.abs(n - (+i)).toFixed(c).slice(2) : "");
 }
}


// WEBPACK FOOTER //
// ./src/app/pipes/br-currency-pipe.ts